var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#81D61E",
    stroke: "#DBDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.5833H15.1667V13.3333H13.3333V10.5833ZM13.3333 17H15.1667V21.5833H13.3333V17ZM22.5 7.8425L11.5 7.83333C10.4917 7.83333 9.66667 8.64917 9.66667 9.66667V24.3333C9.66667 25.3417 10.4917 26.1667 11.5 26.1667H22.5C23.5083 26.1667 24.3333 25.3417 24.3333 24.3333V9.66667C24.3333 8.64917 23.5083 7.8425 22.5 7.8425ZM22.5 24.3333H11.5V16.065H22.5V24.3333ZM22.5 14.25H11.5V9.66667H22.5V14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.35e2d6d61ee38e9ff32b980c078b2588.svg";
export { ForwardRef as ReactComponent };